export default __webpack_public_path__ + "static/media/Skirmisher's Spellsword.307d322f.jpg";